import FilterTypes from 'redux/filters/types';

const initialState = {
  adminLevelsIds: [],
  loadingAdminLevelsIds: false,
  coursesIds: [],
  loadingCoursesIds: false,
  error: null
};

function filtersReducer(state = initialState, { type, payload }) {
  switch (type) {
    case FilterTypes.START_FETCH_APPLICATION_ADMIN_LEVELS:
      return {
        ...state,
        loadingAdminLevelsIds: true,
      };
    case FilterTypes.FETCH_APPLICATION_ADMIN_LEVELS_SUCCESS:
      return {
        ...state,
        loadingAdminLevelsIds: false,
        adminLevelsIds: payload
      };
    case FilterTypes.FETCH_APPLICATION_ADMIN_LEVELS_FAILURE:
      return {
        ...state,
        loadingAdminLevelsIds: false,
        error: payload
      };
    case FilterTypes.START_FETCH_ADMIN_LEVELS_COURSES:
      return {
        ...state,
        loadingCoursesIds: true,
      };
    case FilterTypes.FETCH_ADMIN_LEVELS_COURSES_SUCCESS:
      return {
        ...state,
        loadingCoursesIds: false,
        coursesIds: payload,
      };
    case FilterTypes.FETCH_ADMIN_LEVELS_COURSES_FAILURE:
      return {
        ...state,
        loadingCoursesIds: false,
        error: null,
      };
    default:
      return state;
  }
}

export default filtersReducer;
